var _rect, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D6DADE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9756 23.0826C21.9878 21.8021 24.4788 18.8119 25 14.5413C25 14.5413 6 14.5413 6 14.5413C6.22612 18.8119 8.6844 21.6447 11.8786 23.0826C11.8786 23.0826 18.9756 23.0826 18.9756 23.0826Z",
    stroke: "white",
    strokeWidth: 0.760063
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1009 23.0826H19.0734V24.9843C19.0734 25.0893 18.9883 25.1743 18.8834 25.1743H12.2909C12.186 25.1743 12.1009 25.0893 12.1009 24.9843V23.0826Z",
    stroke: "white",
    strokeWidth: 0.760063
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7889 6C10.8533 8.30765 15.1931 9.23282 12.6993 11.9266",
    stroke: "white",
    strokeWidth: 0.760063,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5779 6C13.6423 8.30765 17.9821 9.23282 15.4883 11.9266",
    stroke: "white",
    strokeWidth: 0.760063,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0183 6C16.0827 8.30765 20.4224 9.23282 17.9287 11.9266",
    stroke: "white",
    strokeWidth: 0.760063,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2477 20.8109C20.0205 20.6105 21.1155 19.534 21.5325 18.6425",
    stroke: "white",
    strokeWidth: 0.760063,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.f7866f6549cc81f0c0bfc7d9545c96f3.svg";
export { ForwardRef as ReactComponent };